import { getIsGrowCometStudentOnboardingFromRedirectUrl } from '#pplx/frontend/apps/ask/subscription/utils/studentUtils.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import { LOGIN_SOURCE_PARAM } from '#pplx/frontend/components/utils/consts.js';
import { useSearchParams } from '#pplx/frontend/router/useSearchParams.js';
import { useMemo } from 'react';
export const useStudentLoginSource = () => {
    const searchParams = useSearchParams();
    return useMemo(() => {
        const loginSource = searchParams?.get(LOGIN_SOURCE_PARAM);
        const isFromStudentCometGrowth = !!getIsGrowCometStudentOnboardingFromRedirectUrl({
            searchParams,
            cleanRedirect: false,
        });
        const isFromStudentLanding = loginSource === ModalOrigin.STUDENT_LANDING_PAGE;
        const isFromStudentCometGrowthCountry = loginSource === ModalOrigin.GROW_COMET_STUDENTS_COUNTRY;
        const isFromStudentFlow = isFromStudentCometGrowth || isFromStudentLanding || isFromStudentCometGrowthCountry;
        return {
            loginSource,
            isFromStudentCometGrowth,
            isFromStudentCometGrowthCountry,
            isFromStudentLanding,
            isFromStudentFlow,
        };
    }, [searchParams]);
};
//# sourceMappingURL=useStudentLoginSource.js.map